import  React from "react";
import { TextField, ITextFieldStyles } from "office-ui-fabric-react";
import { FontSizes } from "@uifabric/fluent-theme";
import { FontWeights } from "office-ui-fabric-react";
import { useField } from "formik";
const textfieldS: Partial<ITextFieldStyles> = {
  root: {
    marginBottom: "16px",
    width: "250px",
  },

  subComponentStyles: {
    label: {
      fontSize: FontSizes.size14,
      fontWeight: FontWeights.semibold,
    },
  },
};

export interface IPassFieldProps {
  name: any,
  label: string,
  disabled?: boolean
  value1: string
  setPrice?: any
}

const PriceInput: React.FC<IPassFieldProps> = ({
  name,
  label,
  disabled,
  value1,
  setPrice
}) => { 

  const [field, { value, error }, { setValue }] = useField(name);

  const onchange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) =>{
    const numValue = newValue ? parseFloat(newValue) : 0;
    setValue(numValue);
    setPrice(numValue);
  }

  return (
    <TextField
      type={"number"}
      label={label}
      disabled={disabled}
      styles={textfieldS}
      onChange={onchange}
      value={value1}
      min={0}
    />
  );
};

export default PriceInput;